/* global Parse */

import React, { Component, useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import Protected from './components/Protected';
import ForecastContainer from './components/ForecastContainer';
import HeatMapContainer from './components/HeatMapContainer';
import FogMapContainer from './components/FogMapContainer';
import Client from './Client';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-93690507-1', {debug: true});

// HOC for protected routes
function RequireAuth({ children }) {
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = React.useState(true);

  useEffect(() => {
    const currentUser = Parse.User.current();
    
    if (!currentUser) {
      navigate('/login');
      setIsChecking(false);
      return;
    }

    currentUser.get('EscaypeKeys').fetch().then(() => {
      console.log(currentUser.get('EscaypeKeys').get('accessKey')); // eslint-disable-line no-console
      console.log(currentUser.get('EscaypeKeys').get('url')); // eslint-disable-line no-console

      const payments = Parse.Object.extend('payments');
      const query = new Parse.Query(payments);
      query.equalTo('username', currentUser.get('username'));

      return query.find();
    }).then(results => {
      console.log(results); // eslint-disable-line no-console

      if (!results[0].get('active')) {
        throw new Error('Please log in with an active account to continue.');
      }

      const query = new Parse.Query(Parse.Session);
      query.equalTo('user', currentUser);

      return query.find();
    }).then(results => {
      console.log(results); // eslint-disable-line no-console

      if (results.length > 5) {
        ReactGA.event({
          category: 'User',
          action: 'ClearSessions',
          label: Parse.User.current().getUsername()
        });

        Parse.User.logOut().then(() => Parse.Object.destroyAll(results)).catch(() => {}).then(() => {
          navigate(`/login?error=${encodeURIComponent('You have exceeded the number of allowed devices on our network. We\'ll log all of your other sessions out for you.')}`);
        });
      } else {
        setIsChecking(false);
      }
    }).catch(err => {
      console.error(err.message); // eslint-disable-line no-console

      return Parse.User.logOut().catch(() => {}).then(() => {
        navigate(`/login?error=${encodeURIComponent(err.message)}`);
      });
    });
  }, [navigate]);

  if (isChecking) {
    return <div>Loading...</div>;
  }

  return children;
}

// Component to track page views
function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
  }, [location]);

  return null;
}

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <PageViewTracker />
        <Routes>
          <Route path='/' element={<Navigate to='/protected' replace />} />
          <Route path='/protected' element={
            <RequireAuth>
              <Protected />
            </RequireAuth>
          }>
            <Route index element={<ForecastContainer nearestNeighbor={Client.nearestNeighbor_v4} />} />
            <Route path='heatmap' element={<HeatMapContainer />} />
            <Route path='fogmap' element={<FogMapContainer />} />
            <Route path='moon' element={<ForecastContainer nearestNeighbor={Client.nearestNeighborMoon_v4} />} />
          </Route>
          <Route path='/login' element={<Login />} />
          <Route path='/forgotpassword' element={<ForgotPassword />} />
        </Routes>
      </BrowserRouter>
    );
  }
}

export default App;
